"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetConfig_1 = require("auto-widget-framework/src/Model/WidgetConfig");
const configs_js_1 = require("../configs/configs.js");
const ContainerParams_1 = require("../Enum/ContainerParams");
class PXWidgetConfig extends WidgetConfig_1.default {
    constructor() {
        super(...arguments);
        this.templates = {};
    }
    static getDefaults() {
        return Object.assign(super.getDefaults(), {
            widgetLang: configs_js_1.configs.dimensions.language,
            priceFormat: configs_js_1.configs.widgetConfigDefaults.priceFormat,
            numberFormat: configs_js_1.configs.widgetConfigDefaults.numberFormat,
            currency: configs_js_1.configs.widgetConfigDefaults.currency,
            dateFormat: configs_js_1.configs.widgetConfigDefaults.dateFormat,
            valuation: null,
            cookieDomain: process.env.REACT_APP_SESSION_COOKIE_DOMAIN,
            hideFinishCta: configs_js_1.configs.widgetConfigDefaults.hideFinishCta,
        });
    }
    getTemplate(id) {
        return this.templates[id];
    }
    setTemplate(id, template) {
        this.templates[id] = template;
        return this;
    }
    getTemplates() {
        return this.templates;
    }
    getWidgetLang() {
        return this.widgetLang;
    }
    getToken() {
        return this.token;
    }
    getPriceFormat() {
        return this.priceFormat;
    }
    getCurrency() {
        return this.currency;
    }
    getNumberFormat() {
        return this.numberFormat;
    }
    getDateFormat() {
        return this.dateFormat;
    }
    getValuation() {
        return this.valuation;
    }
    setValuation(value) {
        this.valuation = value;
        return this;
    }
    getDisableNextStepSellOption() {
        return this.disableNextStepSellOption;
    }
    getHideFinishCta() {
        return this.hideFinishCta;
    }
    setDisableNextStepSellOption(bool) {
        this.disableNextStepSellOption = bool;
        return this;
    }
    setCookieDomain(domain) {
        this.cookieDomain = domain;
        return this;
    }
    getCookieDomain() {
        return this.cookieDomain;
    }
    getContainerParameters() {
        return {
            [ContainerParams_1.ContainerParams.COOKIE_DOMAIN]: this.getCookieDomain(),
        };
    }
    static getValueMapping() {
        const mapping = super.getValueMapping();
        mapping.value = Object.assign(Object.assign({}, mapping.value), { widgetLang: {
                type: "string",
                getter: true
            }, token: {
                type: "string",
                getter: true,
                required: false,
                regex: /[A-Za-z0-9]+/
            }, priceFormat: {
                type: "string",
                getter: true,
                required: true
            }, currency: {
                type: "string",
                getter: true,
                required: true
            }, numberFormat: {
                type: "string",
                getter: true,
                required: true,
            }, dateFormat: {
                type: "string",
                getter: true,
                required: true,
            }, valuation: {
                type: "object",
                getter: true,
                required: false
            }, disableNextStepSellOption: {
                type: "boolean",
                getter: true,
                required: false
            }, cookieDomain: {
                type: "string",
                required: true,
            }, hideFinishCta: {
                type: "boolean",
                getter: true,
                required: false,
            } });
        return mapping;
    }
    /**
     * @inheritDoc
     */
    static fromObject(config) {
        return super.fromObject(config);
    }
}
exports.default = PXWidgetConfig;
